export const vehiclesIncidentsConstants = {
  INIT: 'FETCH_VEHICLES_INCIDENTS_INIT',
  SUCCESS: 'FETCH_VEHICLES_INCIDENTS__SUCCESS',
  UPDATE: 'FETCH_VEHICLES_INCIDENTS__UPDATE',
  FAILURE: 'FETCH_VEHICLES_INCIDENTS__FAILURE',
  CLEAR: 'FETCH_VEHICLES_INCIDENTS__CLEAR',
}
